import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  ReduxCurrentSale,
  selectCurrentSale,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { UserManager } from '../../../managers/user-manager'
import {
  calculateMaxDisplayDiscount,
  isSaleDiscountValid,
} from '../../../sale-calculation/calculate-sale'
import { MAX_DISCOUNT_PERCENT } from '../../../constants'
import { isReturn } from '../../../functions/sale'
import { useUserManager } from '../../../ng-compat/hooks'

interface IsSaleDiscountValidParams {
  checkUserMaxSaleDiscount?: boolean
}
const discountValid = (
  currentSale: ReduxCurrentSale,
  userManager: UserManager,
  params: IsSaleDiscountValidParams = {
    checkUserMaxSaleDiscount: false,
  }
): boolean => {
  const { checkUserMaxSaleDiscount } = params

  const maxDisplayDiscount = calculateMaxDisplayDiscount({
    discountableTotal: currentSale.totals.maxSaleDiscount,
    discountIsPercentage: currentSale.discountIsPercentage,
    maxPercentageDiscount: checkUserMaxSaleDiscount
      ? userManager.getMaxSaleDiscountPercent()
      : MAX_DISCOUNT_PERCENT,
  })

  return isSaleDiscountValid({
    displayDiscount: currentSale.displayDiscount,
    maxDisplayDiscount,
    saleIsReturn: isReturn(currentSale),
  })
}

export const useDiscountInvalid = (
  params?: IsSaleDiscountValidParams
): boolean => {
  const currentSale = useSelector(selectCurrentSale)
  const userManager = useUserManager()
  const [isDiscountInvalid, setIsDiscountInvalid] = useState(false)

  useEffect(() => {
    const checkDiscountValidity = () => {
      const invalid =
        currentSale.displayDiscount !== '0' &&
        !discountValid(currentSale, userManager, params)
      setIsDiscountInvalid(invalid)
    }

    checkDiscountValidity()
  }, [currentSale, userManager, params])

  return isDiscountInvalid
}
